import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LanguageLoader } from '../../../assets/languages/index.js';
import Attachments from "../../../components/features/Attachments.jsx";
import Modal from '../../../components/features/Modal.jsx';
import api from "../../../services/axios.js";
import { config } from "../../../services/config.js";
import { Toastify } from '../../../components/utils/index.js';

const CreateRetail_Orders = () => {
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const id = searchParams.get("id");

	const [account, SetAccount] = useState('');
	const [dataEntry, SetDataEntry] = useState([]);
	const [phoneNumber, setPhoneNumber] = useState('');
	const [nationalNumber, SetNationalNumber] = useState('');
	const [showModal, setShowModal] = useState(false);
	const [hideModal, setFallDownModal] = useState(false);
	const [notFoundEntry, SetNotFoundEntry] = useState(false);
	const [pendingPhoneSelect, setPendingPhoneSelect] = useState(false);

	const [color, SetColor] = useState('');
	const [engineNumber, SetEngineNumber] = useState('');
	const [chassisNumber, SetChassisNumber] = useState('');
	const [cashPrice, SetCashPrice] = useState('');
	const [loanPrice, SetLoanPrice] = useState('');
	const [attachments, SetAttachment] = useState([]);
	const [retailOrderId, SetRetailOrderId] = useState('');

	const [showProductModal, setShowProductModal] = useState(false);
	const [productSearch, SetProductSearch] = useState('');
	const [productSearchResult, SetProductSearchResult] = useState([]);
	const [selectedParts, setSelectedParts] = useState([]);
	const [deletedParts, setDeletedParts] = useState([]);
	const [typingTimeout, setTypingTimeout] = useState(null);

	useEffect(() => {
		if (id) {
			FetchRetailOrderById(id);
			return;
		}
		const phoneParam = searchParams.get('phone');
		if (phoneParam && phoneParam.length) {
			setPhoneNumber(phoneParam);
			setPendingPhoneSelect(true);
			setShowModal(true);
			handleSearchByPhone(phoneParam);
		}
	}, [searchParams]);

	const FetchRetailOrderById = async (recordId) => {
		try {
			const APIResponse = await api.post(
				config.api + '?method=FetchRetailOrderById',
				JSON.stringify({ id: recordId })
			);
			const resp = APIResponse?.data || APIResponse;
			if (!resp?.id) {
				Toastify("خطا در دریافت اطلاعات سفارش");
				return;
			}
			SetRetailOrderId(resp.id);
			SetColor(resp.nikrun_order_coler || '');
			SetEngineNumber(resp.nikrun_order_engine || '');
			SetChassisNumber(resp.nikrun_order_number || '');
			SetCashPrice(resp.nikrun_order_price || '');
			SetLoanPrice(resp.nikrun_order_loan || '');
			SetAccount(resp.account || '');
			if (resp.billing_account_id || resp.account_id) {
				SetDataEntry([{
					id: resp.billing_account_id || resp.account_id,
					name: resp.account || '',
				}]);
			}
			if (Array.isArray(resp.selectedParts)) {
				setSelectedParts(resp.selectedParts.map((item) => ({
					id: item.id || '',
					product_id: item.product_id,
					name: item.name,
					part_number: item.part_number,
					product_list_price: item.product_list_price,
					product_qty: item.product_qty || 1,
					main_unit_type: item.main_unit_type,
					secondary_unit_type: item.secondary_unit_type,
					item_description: item.item_description || '',
					deleted: 0,
				})));
			}
			if (Array.isArray(resp.attachments)) {
				SetAttachment(resp.attachments);
			}
			setDeletedParts([]);
		} catch (error) {
			Toastify("خطا در دریافت اطلاعات سفارش");
		}
	};

	useEffect(() => {
		if (!pendingPhoneSelect) return;
		if (Array.isArray(dataEntry)) {
			if (dataEntry.length === 1) {
				FillInputes(0);
				setShowModal(false);
				setPendingPhoneSelect(false);
			} else if (dataEntry.length > 1) {
				setShowModal(true);
				setPendingPhoneSelect(false);
			}
		}
	}, [dataEntry, pendingPhoneSelect]);

	useEffect(() => {
		if (showProductModal) {
			searchProducts('');
		}
	}, [showProductModal]);

	const handleSearchByPhone = async (value) => {
		SetNotFoundEntry(false);
		if (value.length === 0) {
			if (!account || account.length === 0) {
				SetDataEntry([]);
			}
			return;
		}
		SetNationalNumber('');
		const APIResponse = await api.post(
			config.api + '?method=DuplicatePhoneNumber',
			JSON.stringify({ phoneNumber: value })
		);
		if (APIResponse.result == true) {
			if (Array.isArray(APIResponse.data)) {
				SetDataEntry(APIResponse.data);
			} else if (APIResponse.data && typeof APIResponse.data === 'object') {
				SetDataEntry([APIResponse.data]);
			} else {
				SetDataEntry([]);
			}
		} else {
			SetNotFoundEntry(true);
		}
	};

	const handleSearchByNationalNumber = async (value) => {
		SetNotFoundEntry(false);
		if (value.length === 0) {
			if (!account || account.length === 0) {
				SetDataEntry([]);
			}
			return;
		}
		if (value.length < 10) {
			Toastify('کد ملی وارد شده صحیح نیست');
			return;
		}
		setPhoneNumber('');
		const APIResponse = await api.post(
			config.api + '?method=DuplicateNationalCode',
			JSON.stringify({ nationalCode: value })
		);
		if (APIResponse.result == true) {
			const entry = APIResponse.data;
			SetDataEntry(Array.isArray(entry) ? entry : [entry]);
			SetNotFoundEntry(false);
		} else {
			SetNotFoundEntry(true);
		}
	};

	const FillInputes = async (index) => {
		setFallDownModal(true);
		if (Array.isArray(dataEntry) && dataEntry[index]) {
			const selectedRecord = dataEntry[index];
			const reordered = [selectedRecord, ...dataEntry.filter((_, i) => i !== index)];
			SetDataEntry(reordered);
			if (selectedRecord?.name) {
				SetAccount(selectedRecord.name);
			}
		}
	};

	const newCustomer = () => {
		const phoneParam = phoneNumber ? `&phone=${encodeURIComponent(phoneNumber)}` : '';
		window.location.href = `/dynamic/CreateAccounts?BackTo=CreateRetail_Orders${phoneParam}`;
	};

	const handleLiveSearch = (value) => {
		SetProductSearch(value);
		if (typingTimeout) {
			clearTimeout(typingTimeout);
		}
		setTypingTimeout(setTimeout(() => {
			if (value && value.length >= 3) {
				searchProducts(value);
			} else {
				searchProducts('');
			}
		}, 400));
	};

	const searchProducts = async (value) => {
		const APIResponse = await api.post(
			config.api + '?method=ProductList',
			JSON.stringify({ ProductListSearch: value })
		);
		if (APIResponse && APIResponse.result == true) {
			SetProductSearchResult(APIResponse.data || []);
		} else {
			SetProductSearchResult([]);
		}
	};

	const selectProduct = (index) => {
		const selectedItem = productSearchResult[index];
		if (!selectedItem) {
			return;
		}
		setSelectedParts(prev => {
			const exists = prev.some(p => p.product_id === selectedItem.id || p.id === selectedItem.id);
			if (exists) {
				return prev;
			}
			return [...prev, {
				id: '',
				product_id: selectedItem.id,
				name: selectedItem.name,
				part_number: selectedItem.part_number,
				product_list_price: selectedItem.price,
				product_qty: 1,
				main_unit_type: selectedItem.main_usage_unit,
				secondary_unit_type: selectedItem.secondary_usage_unit,
				units_ratio: selectedItem.units_ratio,
				item_description: '',
				deleted: 0,
			}];
		});
	};

	const HandleAttachment = (value) => {
		SetAttachment(value);
	};

	const getLineitemsPayload = () => {
		const activeItems = (selectedParts || []).filter(item => item && !item.deleted);
		return [...activeItems, ...(deletedParts || [])];
	};

	const removeProduct = (item) => {
		if (item.id) {
			setDeletedParts(prev => [...prev, { ...item, deleted: '1' }]);
		}
		setSelectedParts(prev => prev.filter(p => p.product_id !== item.product_id));
	};

	const DoSave = async () => {
		if (!dataEntry?.[0]?.id) {
			Toastify("حساب انتخاب نشده است");
			return;
		}
		const items = getLineitemsPayload();
		const activeItems = items.filter(item => item && !item.deleted);
		if (!activeItems.length) {
			Toastify("انتخاب حداقل یک محصول الزامی است");
			return;
		}
		const data = {
			id: retailOrderId || id || undefined,
			billing_account_id: dataEntry[0].id,
			nikrun_order_coler: color,
			nikrun_order_engine: engineNumber,
			nikrun_order_number: chassisNumber,
			nikrun_order_price: cashPrice,
			nikrun_order_loan: loanPrice,
			lineitems: items,
			attachments: attachments,
		};
		const APIResponse = await api.post(
			config.api + '?method=SaveRetailOrder',
			JSON.stringify(data)
		);
		if (APIResponse && APIResponse.id) {
			navigate(`/detail/Retail_Orders/${APIResponse.id}`);
			return;
		}
		Toastify("خطا در ذخیره سفارش");
	};

	const attachmentDrop = {
		image: 'فایل ضمیمه',
	};

	return <>
		<div className='title flex justify-between w-full'>
			<h6>{id ? 'ویرایش سفارش خرده فروشی' : 'ایجاد سفارش خرده فروشی'}</h6>
			<div className="flex">
				<button onClick={() => navigate('/list/Retail_Orders')} type="button" className='btn btn-secondary'>
					{language.CANCEL}
				</button>
				<button onClick={DoSave} type="button" className='btn btn-primary'>
					{language.SAVE}
				</button>
			</div>
		</div>
		<div className="flex flex-wrap">
			<div className="Field_Container">
				<div className="flex">
					<label>مشتری<span className="text-danger">*</span></label>
				</div>
				<input
					type="text"
					className="form-control"
					onChange={(e) => SetAccount(e.target.value)}
					onClick={() => setShowModal(true)}
					value={account}
					disabled={account !== ''}
				/>
			</div>
			<Modal
				handler={<></>}
				trigger={showModal}
				fallDown={hideModal}
				onClose={() => {
					setShowModal(false);
					if ((!account || account.length === 0) && !dataEntry?.[0]?.id) {
						SetDataEntry([]);
					}
					setPhoneNumber('');
					SetNationalNumber('');
					SetNotFoundEntry(false);
				}}
				title="جستجو مشتری"
			>
				<div className="flex flex-wrap">
					<div className="Field_Container">
						<div className="flex">
							<label>شماره تماس<span className="text-danger">*</span></label>
						</div>
						<input
							type="text"
							className="form-control"
							onChange={(e) => {
								const value = e.target.value;
								setPhoneNumber(value);
								if (value.length === 0 && nationalNumber.length === 0) {
									if (!account || account.length === 0) {
										SetDataEntry([]);
									}
									SetNotFoundEntry(false);
								}
							}}
							onBlur={(e) => handleSearchByPhone(e.target.value)}
							value={phoneNumber}
						/>
					</div>
					<div className="Field_Container">
						<div className="flex">
							<label>کدملی<span className="text-danger">*</span></label>
						</div>
						<input
							type="text"
							className="form-control"
							onChange={(e) => {
								const value = e.target.value;
								SetNationalNumber(value);
								if (value.length === 0 && phoneNumber.length === 0) {
									if (!account || account.length === 0) {
										SetDataEntry([]);
									}
									SetNotFoundEntry(false);
								}
							}}
							onBlur={(e) => handleSearchByNationalNumber(e.target.value)}
							value={nationalNumber}
						/>
					</div>
					{dataEntry?.length > 0 ? (
						<table className="w-full border border-gray-300">
							<thead>
								<tr className="bg-gray-200">
									<th className="border p-2">شماره تماس</th>
									<th className="border p-2">نام</th>
									<th className="border p-2">عملیات</th>
								</tr>
							</thead>
							<tbody>
								{dataEntry.map((item, index) => (
									<tr key={item.id} className="border">
										<td className="border p-2">{item.phone_number}</td>
										<td className="border p-2">{item.name}</td>
										<td className="border p-2">
											<button onClick={() => FillInputes(index)} className="btn-primary">
												انتخاب
											</button>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					) : notFoundEntry ? (
						<button
							type="button"
							onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); newCustomer(); }}
							onClick={(e) => e.preventDefault()}
							className="btn btn-primary"
						>
							ایجاد مشتری جدید
						</button>
					) : null}
				</div>
			</Modal>

			<div className="Field_Container">
				<div className="flex">
					<label>رنگ</label>
				</div>
				<input
					type="text"
					className="form-control"
					value={color}
					onChange={(e) => SetColor(e.target.value)}
				/>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>شماره انجین</label>
				</div>
				<input
					type="text"
					className="form-control"
					value={engineNumber}
					onChange={(e) => SetEngineNumber(e.target.value)}
				/>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>شماره شاسی</label>
				</div>
				<input
					type="text"
					className="form-control"
					value={chassisNumber}
					onChange={(e) => SetChassisNumber(e.target.value)}
				/>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>قیمت پرداخت نقدی</label>
				</div>
				<input
					type="text"
					className="form-control"
					value={cashPrice}
					onChange={(e) => SetCashPrice(e.target.value)}
				/>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>قیمت و اقساط وام</label>
				</div>
				<input
					type="text"
					className="form-control"
					value={loanPrice}
					onChange={(e) => SetLoanPrice(e.target.value)}
				/>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>ضمیمه</label>
				</div>
				<Attachments types={attachmentDrop} single={false} defaultValue={attachments} onChange={(value) => HandleAttachment(value)}></Attachments>
			</div>
			<div className="w-full">
				<div className="flex">
					<label>ردیف محصولات <span className="text-danger">*</span></label>
				</div>
				<button onClick={() => setShowProductModal(true)} type="button" className='btn btn-primary'>
					افزودن محصول
				</button>
				<Modal
					handler={<></>}
					trigger={showProductModal}
					fallDown={false}
					onClose={() => setShowProductModal(false)}
					title="جستجو محصولات"
				>
					<div className="flex">
						<label>نام یا کد محصول</label>
					</div>
					<input
						placeholder="حداقل سه کاراکتر وارد کنید ..."
						type="text"
						className="form-control mb-4"
						value={productSearch || ''}
						onChange={(e) => handleLiveSearch(e.target.value)}
					/>
					<div className="max-h-[350px]">
						<table className="w-full border border-gray-300">
							<thead>
								<tr className="bg-gray-200">
									<th className="border p-2">نام محصول</th>
									<th className="border p-2">کد محصول</th>
									<th className="border p-2">عملیات</th>
								</tr>
							</thead>
							<tbody>
								{Array.isArray(productSearchResult) ? productSearchResult.map((item, index) => (
									<tr key={item.id} className="border">
										<td className="border p-2">{item.name}</td>
										<td className="border p-2">{item.part_number}</td>
										<td className="border p-2">
											<button onClick={() => selectProduct(index)} className="btn-primary">
												انتخاب
											</button>
										</td>
									</tr>
								)) : null}
							</tbody>
						</table>
					</div>
				</Modal>
				{selectedParts.length > 0 && (
					<table className="w-full border border-gray-300 mt-4">
						<thead>
							<tr className="bg-gray-200">
								<th className="border p-2">نام محصول</th>
								<th className="border p-2">کد محصول</th>
								<th className="border p-2">تعداد</th>
								<th className="border p-2">عملیات</th>
							</tr>
						</thead>
						<tbody>
							{selectedParts.map((item) => (
								<tr key={item.product_id}>
									<td className="border p-2">{item.name}</td>
									<td className="border p-2">{item.part_number}</td>
									<td className="border p-2">
										<input
											type="number"
											className="border w-16 p-1"
											value={item.product_qty}
											min={1}
											onChange={(e) => {
												const value = parseInt(e.target.value) || 1;
												setSelectedParts(prev => prev.map(p =>
													p.product_id === item.product_id ? { ...p, product_qty: value } : p
												));
											}}
										/>
									</td>
									<td className="border p-2">
										<button
											onClick={() => removeProduct(item)}
											className="text-red-500 hover:underline"
										>
											حذف
										</button>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				)}
			</div>
		</div>
	</>
}

export default CreateRetail_Orders;
